import { cx } from '../utils/cx.js';

/** 処理中の印。画面全体を覆わない（C-11: スピナーは全画面遷移のときだけ） */
export function Spinner({ size = 20, className, label }: { size?: 16 | 20 | 24 | 28; className?: string; label?: string }) {
  return (
    <span
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cx('inline-block shrink-0 animate-spin rounded-pill border-2 border-current border-r-transparent', className)}
      style={{ width: size, height: size }}
    />
  );
}
